import type { ActivityModule } from '../../core/activity';
import { runLearnArithmeticActivity, type LearnArithmeticLevelsFile } from '../../shared/learn-arithmetic-runner';
import levelsData from './levels.json';

const LEVELS = (levelsData as LearnArithmeticLevelsFile).levels;

export const learnSubtractions: ActivityModule = {
  id: 'learn_subtractions',
  title: 'Aprender subtração',
  description: 'Veja a subtração, preencha círculos com a quantidade certa para representar o resultado.',
  ageMin: 5,
  ageMax: 8,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/learn_subtractions/icon.svg',
  category: 'aritmetica',
  totalLevels: LEVELS.length,
  mount: (ctx) =>
    runLearnArithmeticActivity(ctx, {
      activityId: 'learn_subtractions',
      title: 'Aprender subtração',
      levels: LEVELS,
    }),
};
